import { useEffect } from 'react'

import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router'

import {
  Network,
  Space as SpaceType,
  SpaceType as SpaceTypeType,
} from '@tribeplatform/gql-client/types'
import { useSpace, useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { SlateRenderer } from '@tribeplatform/slate-kit/components'

import { useAnalytics } from '../../hooks/useAnalytics'

export const Space = ({
  network,
  space: _space,
}: {
  network: Network
  space: SpaceType
}) => {
  const { data: space } = useSpace({
    variables: {
      id: _space?.id,
    },
    useQueryOptions: {
      enabled: false,
      placeholderData: _space,
    },
  })

  const { pathname } = useLocation()
  const { generatePath, matchPath } = useSpaceUtil()
  const analytics = useAnalytics({
    target: { spaceId: space?.id },
  })

  const { title: pageTitle = space?.name || space?.slug } =
    space?.seoDetail || {}
  const title = `${pageTitle} - ${network.name}`

  useEffect(() => {
    analytics.trackPageView(title)
  }, [title])

  if (!space) return null
  const { params = null } = matchPath(space, pathname) || {}
  return (
    <>
      <Helmet>
        {space?.type === SpaceTypeType.CUSTOM && pathname !== '/' && (
          <link
            rel="alternate"
            type="application/rss+xml"
            title={space?.name}
            href={`https://${network?.domain}/rss/${space?.id}/posts`}
          />
        )}
      </Helmet>
      <SlateRenderer
        slate={space.slate}
        path={generatePath(space, params)}
        additionalContext={{ space, urlParams: params || {} }}
      />
    </>
  )
}
